/**
 * Internal depedencies
 */
import { removeItemFromLayout } from 'state/dashboard-layouts/actions';
import { getLayoutId } from 'state/dashboard/selectors';

export default (itemId) => (dispatch, getState) => {
	return dispatch(removeItemFromLayout(getLayoutId(getState()), itemId));
};
